/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadSlot
 */
export interface UploadSlot {
    /**
     * 
     */
    index: number;
    /**
     * 
     */
    uploadUrl: string;
    /**
     * 
     */
    s3Key: string;
}

/**
 * Check if a given object implements the UploadSlot interface.
 */
export function instanceOfUploadSlot(value: object): value is UploadSlot {
    if (!('index' in value) || value['index'] === undefined) return false;
    if ((!('uploadUrl' in (value as Record<string, any>)) && !('upload_url' in (value as Record<string, any>))) || ((value as Record<string, any>)['uploadUrl'] === undefined && (value as Record<string, any>)['upload_url'] === undefined)) return false;
    if ((!('s3Key' in (value as Record<string, any>)) && !('s3_key' in (value as Record<string, any>))) || ((value as Record<string, any>)['s3Key'] === undefined && (value as Record<string, any>)['s3_key'] === undefined)) return false;
    return true;
}

export function UploadSlotFromJSON(json: any): UploadSlot {
    return UploadSlotFromJSONTyped(json, false);
}

export function UploadSlotFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadSlot {
    if (json == null) {
        return json;
    }
    return {
        
        'index': json['index'],
        'uploadUrl': json['upload_url'],
        's3Key': json['s3_key'],
    };
}

export function UploadSlotToJSON(json: any): UploadSlot {
    return UploadSlotToJSONTyped(json, false);
}

export function UploadSlotToJSONTyped(value?: UploadSlot | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'index': value['index'],
        'upload_url': value['uploadUrl'],
        's3_key': value['s3Key'],
    };
}

